export type UserProfileType = 'Administrator' | 'Zone Spoc' | 'Common User';

export interface UserProfile {
  profileType: UserProfileType;
}

export interface UserProfileContextData {
  profile: UserProfile | null;
  isEibZoneSpocUser: boolean;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  checkEIBZoneSpocUser: () => Promise<void>;
}

// Helper functions for profile checks
export const isAdministrator = (profile: UserProfile | null): boolean => {
  return profile?.profileType === 'Administrator';
};

export const isZoneSpoc = (profile: UserProfile | null): boolean => {
  return profile?.profileType === 'Zone Spoc';
};

export const isCommonUser = (profile: UserProfile | null): boolean => {
  return profile?.profileType === 'Common User';
};

export const hasProfileAccess = (
  profile: UserProfile | null,
  allowedProfiles: UserProfileType[]
): boolean => {
  return profile ? allowedProfiles.includes(profile.profileType) : false;
};
